import {IFilterCategoryDefinition} from "../interfaces/filter-category-definition.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {GameInfo} from "../../games/game-info";
import {Check} from "@sparkware/app-utils";
import {ArenaGameFilter} from "./arena-game-filter";
import {Nullable} from "../../../../common/types/nullable-types";
import {IArenaGameFiltersCategory} from "./arena-game-filters-category.interface";
import {computed} from "mobx";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";

export class ArenaGameFiltersCategory implements IArenaGameFiltersCategory {
    constructor(private readonly categoryDefinition: IFilterCategoryDefinition,
                private readonly services: IServiceFactoryExtended) {
    }

    get title(): string {
        return this.categoryDefinition.title;
    }

    private _filters: Nullable<ArenaGameFilter[]> = null;
    get filters(): ArenaGameFilter[] {
        if(!this._filters) {
            this._filters = this._createFiltersForCurrentArena();
        }
        return this._filters;
    }

    get isApplicableForCurrentArena(): boolean {
        return this.filters.length > 0;
    }

    @computed
    get appliedFilters(): ArenaGameFilter[] {
        return this.filters.filter(f => f.isApplied);
    }

    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {

        const appliedFilters = this.appliedFilters;

        if(appliedFilters.length === 0) {
            return ApplyGameFilterResult.NotApplicable;
        }

        return this.categoryDefinition.applyFilters(gameInfo, appliedFilters);
    }

    isGameIncludedInThisCategory(gameInfo: GameInfo): boolean {
        for(let f of this.filters) {
            if(ApplyGameFilterResult.IncludeGame === f.applyFilter(gameInfo)) {
                return true;
            }
        }

        return false;
    }



    private _createFiltersForCurrentArena(): ArenaGameFilter[] {

        const currentArenaFiltersConfigurations = this.services.gamesFilter.currentArenaFiltersConfigurationsMap;
        if(Check.isEmpty(currentArenaFiltersConfigurations)) {
            return [];
        }


        return this.categoryDefinition.availableFilters.filter(f => currentArenaFiltersConfigurations[f.id])
            .map(f => new ArenaGameFilter(f, currentArenaFiltersConfigurations[f.id].filterConfiguration, this.services));
    }
}